import { AxiosHeaders, InternalAxiosRequestConfig } from 'axios';
import i18next from 'i18next';

/**
 * This interceptor is used to intercept all http calls via axios,
 * and place token within authorization header.
 */
export const authAxiosInterceptor = () => {
  const insertAcceptLanguageHeader = (config: InternalAxiosRequestConfig) => {
    if (!config.headers) {
      config.headers = new AxiosHeaders();
    }
    config.headers['Accept-Language'] = i18next.language;
    return config;
  };

  return async (config: InternalAxiosRequestConfig) => {
    insertAcceptLanguageHeader(config);
    return config;
  };
};
